/* Tour filter + scroll reveals.
   Mirrors the React behaviour: region radiogroup with roving tabindex and
   arrow-key navigation, debounced city/venue search, state mirrored into the
   URL so a filtered link is shareable, and a polite live region for counts. */
(function () {
  "use strict";

  var root = document.querySelector("[data-tour-filter]");
  var list = document.querySelector("[data-tour-list]");

  if (root && list) {
    var options = Array.prototype.slice.call(root.querySelectorAll("[data-region-option]"));
    var search = root.querySelector("[data-tour-search]");
    var label = root.querySelector("[data-filter-label]");
    var status = root.querySelector("[data-tour-status]");
    var empty = document.querySelector("[data-tour-empty]");
    var count = document.querySelector("[data-shows-count]");
    var items = Array.prototype.slice.call(list.querySelectorAll(".tour-item"));

    var params = new URLSearchParams(location.search);
    /* The valid set is read from the pills actually rendered, not hardcoded.
       Country pills only appear when that country has shows, so a hardcoded
       list would either accept a country with no dates — showing an empty
       page — or need editing every time a leg is added. */
    var VALID = options.map(function (o) { return o.getAttribute("data-region-option"); });

    /* A pill's URL token and the value it matches rows on are different:
       ?region=deutschland selects the pill whose rows carry country "DE".
       Absent data-match, the token matches itself (ALL, UK). */
    var MATCH = {};
    options.forEach(function (o) {
      var token = o.getAttribute("data-region-option");
      MATCH[token] = o.getAttribute("data-match") || token;
    });

    /* Accept a pill's match value as an alias for its token, so links shared
       as ?region=DE before the countries were renamed still resolve. Falling
       back to ALL rather than 404ing means a stale link lands on the full
       listing, never an empty one. */
    function resolveRegion(raw) {
      if (VALID.indexOf(raw) !== -1) return raw;
      for (var i = 0; i < options.length; i++) {
        if (options[i].getAttribute("data-match") === raw) {
          return options[i].getAttribute("data-region-option");
        }
      }
      return "ALL";
    }

    var region = resolveRegion((params.get("region") || "ALL").toUpperCase());
    var query = (params.get("q") || "").trim().toLowerCase();

    if (search) search.value = params.get("q") || "";

    /* No EU entry: that pill was removed, so ?region=EU falls through to ALL
       and this map is never asked for it. Add a line here when adding a pill. */
    var LABELS = {
      ALL: "All Dates", UK: "UK Dates",
      DEUTSCHLAND: "Dates in Deutschland", NEDERLAND: "Dates in Nederland",
    };

    function apply(pushUrl) {
      var visible = 0;

      items.forEach(function (item) {
        /* One pill row spans two levels: UK/EU are regions, DE/NL are
           countries. Matching either attribute is what lets them coexist —
           a Berlin row carries region EU and country DE, so it appears under
           both, which is the truthful answer to both questions. */
        var want = MATCH[region] || region;
        var matchesRegion =
          region === "ALL" ||
          item.getAttribute("data-region") === want ||
          item.getAttribute("data-country") === want;
        var haystack = item.getAttribute("data-search") || "";
        var matchesQuery = !query || haystack.indexOf(query) !== -1;
        var show = matchesRegion && matchesQuery;
        item.hidden = !show;
        if (show) visible++;
      });

      options.forEach(function (opt) {
        var on = opt.getAttribute("data-region-option") === region;
        opt.setAttribute("aria-checked", on ? "true" : "false");
        opt.setAttribute("tabindex", on ? "0" : "-1");
      });

      if (label) label.textContent = LABELS[region];
      if (count) count.textContent = String(visible);
      if (empty) empty.hidden = visible !== 0;
      if (status) {
        status.textContent =
          visible === 0
            ? "No shows match your filters. Showing 0 of " + items.length + " shows."
            : "Showing " + visible + " of " + items.length + " shows.";
      }

      if (pushUrl) {
        var next = new URLSearchParams();
        if (region !== "ALL") next.set("region", region);
        if (query) next.set("q", query);
        var qs = next.toString();
        history.replaceState(null, "", qs ? location.pathname + "?" + qs : location.pathname);
      }
    }

    /* Changing region clears the search.

       The pills are the primary axis; the search box refines within one.
       Carrying a refinement across an axis change produces results nobody
       asked for, and in one case a dead end: arriving from an ad on
       ?region=UK&q=london and clicking Deutschland matched zero rows, because
       no German row contains "london" — one click from a filtered landing page
       to "No shows match your filters".

       Clicking All had the same shape of bug more quietly: it announced 20
       shows and rendered 3, because the query survived.

       Typing in the search does NOT clear the region — searching inside a
       region is a sensible thing to want, and the active pill stays visible
       to say so. The asymmetry is deliberate. */
    function selectRegion(value) {
      region = value;
      query = "";
      if (search) search.value = "";
      apply(true);
    }

    options.forEach(function (opt, index) {
      opt.addEventListener("click", function () {
        selectRegion(opt.getAttribute("data-region-option"));
      });

      opt.addEventListener("keydown", function (event) {
        var next = null;
        if (event.key === "ArrowRight" || event.key === "ArrowDown") next = (index + 1) % options.length;
        else if (event.key === "ArrowLeft" || event.key === "ArrowUp") next = (index - 1 + options.length) % options.length;
        else if (event.key === "Home") next = 0;
        else if (event.key === "End") next = options.length - 1;
        if (next === null) return;

        event.preventDefault();
        selectRegion(options[next].getAttribute("data-region-option"));
        options[next].focus();
      });
    });

    if (search) {
      var timer;
      search.addEventListener("input", function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          query = search.value.trim().toLowerCase();
          apply(true);
        }, 200);
      });
    }

    apply(false);
  }

  /* -------------------------------------------------------------------------
     Keep the hero video playing.

     iOS blocks autoplay in Low Power Mode and occasionally after a bfcache
     restore, leaving a paused first frame with a play triangle over it. The
     attributes are set server-side too, but Safari sometimes needs them set as
     properties before it will honour a play() call — so we set both, then ask
     politely and retry on the next user gesture.
  ------------------------------------------------------------------------- */
  var heroVideos = Array.prototype.slice.call(
    document.querySelectorAll(".hero__art video, .show__art video")
  );

  if (heroVideos.length) {
    var kick = function () {
      heroVideos.forEach(function (v) {
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.setAttribute("playsinline", "");
        v.setAttribute("webkit-playsinline", "");
        if (v.paused) {
          var attempt = v.play();
          // Older Safari returns undefined rather than a promise.
          if (attempt && typeof attempt.catch === "function") attempt.catch(function () {});
        }
      });
    };

    kick();
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) kick();
    });
    window.addEventListener("pageshow", kick);

    // One-shot: the first real interaction satisfies the gesture requirement
    // on devices that refused the initial autoplay.
    var once = function () {
      kick();
      ["touchstart", "pointerdown", "scroll", "keydown"].forEach(function (evt) {
        window.removeEventListener(evt, once);
      });
    };
    ["touchstart", "pointerdown", "scroll", "keydown"].forEach(function (evt) {
      window.addEventListener(evt, once, { passive: true, once: true });
    });
  }

  /* Scroll reveals — additive, and skipped entirely under reduced motion. */
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var targets = Array.prototype.slice.call(document.querySelectorAll(".reveal"));

  if (reduced || !("IntersectionObserver" in window)) {
    targets.forEach(function (el) { el.classList.add("is-visible"); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.2 }
  );

  targets.forEach(function (el) { observer.observe(el); });
})();
